import { matchPath } from 'react-router-dom';

export const getParams = (pathname: string, paths: string[]): { [key: string]: string } => {
  const matchPackage = matchPath(pathname, {
    path: paths
  });

  return (matchPackage && matchPackage.params) || {};
};
